import { useContext, useState } from "react";
import { Drawer } from "antd";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { SpinLZ } from "../../design/Spinner/SpinLZ";
import { BlockReviewsKpis } from "../../../pages/menuReports/blocks/BlockReviewsKpis";
import { BlockReviewsGlobal } from "../../../pages/menuReports/blocks/BlockReviewsGlobal";
import { BlockReviewsByLocation } from "../../../pages/menuReports/blocks/BlockReviewsByLocation";
import SelectPeriod from "../selectMonths/SelectPeriod";
import { PageFilters, PageFilterField } from "../../../pages/common/PageFilters";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";
import { EmptyStateBox } from "../../design/EmptyStateBox/EmptyStateBox";


export const LocationReviewsStatsDrawer = () => {

    const { projectGroup } = useAuth();
    
    const [reviewsKPIs, setReviewsKPIs] = useState<any>(null);
    const [reviewsData, setReviewsData] = useState<any>();
    const [isLoading, setIsLoading] = useState(true);
    const [blockAggregate, setBlockAggregate] = useState<any>();
    const [blockListVisible, setBlockListVisible] = useState<any>();
    const [period, setPeriod] = useState<any>();
    const [recentPeriod, setRecentPeriod] = useState<any>();
    
    const { locationReviewsStatsDrawer, setLocationReviewsStatsDrawer} = useContext(DrawerContext)
    const [selectedType, setSelectedType] = useState(locationReviewsStatsDrawer.selectedType);    
    
    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + locationReviewsStatsDrawer.location.groupAccount + '/summary/reviews/' + locationReviewsStatsDrawer.location.name + `?periodOpt=${selectedType}`, {}, [],    
        (data: any) => {
            setReviewsKPIs(data.reviewsKPIs);
            setReviewsData(data);
            setIsLoading(false);
            setPeriod(data.period);
            setRecentPeriod(data.recentPeriod);
            setBlockAggregate(data.blockAggregate);
            setBlockListVisible(data.blockListVisible);
        });

    const hasReviews = Number(reviewsKPIs?.numberOfReviews) > 0;

    return (

        <Drawer
          title={
              <DrawerPanelTitle
                title="Métricas de Reputación"
                location={locationReviewsStatsDrawer.location}
              />
            }
            placement="right"
            width={'75%'}
            open={true}
            onClose={() => setLocationReviewsStatsDrawer(null)}
            {...drawerPanelStyles}>
                {isLoading ? 
                <SpinLZ /> 
                : 
                <div className="card-container">                                        
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                    <PageFilters>
                      <PageFilterField label='Periodo'>
                        <SelectPeriod setSelectedType={setSelectedType} defaultValue={selectedType}/>
                      </PageFilterField>
                    </PageFilters>
                  </div>
                    {!hasReviews ? (
                        <EmptyStateBox
                            title="No hay reseñas en el periodo seleccionado"
                            description="Prueba a ampliar el periodo o selecciona otro rango de fechas."
                            style={{ marginTop: 24 }}
                        />
                    ) : (
                        <>
                            {blockAggregate && reviewsKPIs && (
                                <BlockReviewsKpis
                                    reviewsKPIs={reviewsKPIs}
                                    period={period}
                                    recentPeriod={recentPeriod}
                                    minMax={blockListVisible}
                                    showRecent={false}
                                />
                            )}
                            {blockAggregate && reviewsData && (
                                <BlockReviewsGlobal
                                    data={reviewsData}
                                    reviewsKPIs={reviewsKPIs}
                                    recentPeriod={recentPeriod}
                                />
                            )}
                            <br/>
                            {blockListVisible && reviewsData && (
                                <BlockReviewsByLocation
                                    data={reviewsData.locationsKpis}
                                    showButtons={false}
                                    period={period}
                                    recentPeriod={recentPeriod}
                                />
                            )}
                        </>
                    )}
                </div>
                }
        </Drawer>
    )
}
